import * as React from 'react';
import { useState } from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { updateProspectUserProfile } from '../../../../../api/ProspectUserProfile';
import { GuestCard, updateGuestCard } from '../../../../../api/TourSignup';
import Button from '../../../../common/form/Button';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import { refreshJwt } from '../../../../../api/Shared';
import { withSourceMediumAndCampaign } from '../../../../../utilities/sourceData';

interface Props {
    guestCard: GuestCard;
    updateEmailDisplay: (email: string) => void;
}

const ProspectUpdateEmailPopup = (props: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [newEmail, setNewEmail] = useState(props.guestCard.profile.email);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const validateEmail = (email: string): boolean => {
        const emailPattern = /^(?!.*\.{2})[a-zA-Z0-9._%+-]+(?:\.[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    };

    const handleSubmit = async () => {
        if (!validateEmail(newEmail)) {
            setErrorMessage("Please enter a valid email address.");
            return;
        }
        setIsLoading(true);

        let profileResult = await updateProspectUserProfile({
            ...props.guestCard.profile,
            email: newEmail
        });
        let guestCardResult = await updateGuestCard(
            props.guestCard.propertyId,
            props.guestCard.guestCardGuid,
            withSourceMediumAndCampaign(props.guestCard)
        );

        if (profileResult.success && guestCardResult.success) {
            await refreshJwt();
            setIsLoading(false);
            props.updateEmailDisplay(newEmail);
            setModalOpen(false);
        } else {
            setIsLoading(false);
            setErrorMessage([profileResult.error, guestCardResult.error].join(';'));
        }
    };

    return (
        <div>
            <button onClick={() => setModalOpen(true)} className="edit-guest-card-email">
                Edit
            </button>
            <Modal isOpen={modalOpen}>
                <LoadingOverlay show={isLoading} inBootstrapColumn={false} />
                <ModalBody className="prospect-update-email-popup">
                    <FormValidationDisplay errorMessage={errorMessage} />
                    <label>Edit Email Address</label>
                    <input
                        value={newEmail}
                        onChange={e => setNewEmail(e.target.value)}
                        className="form-control"
                    />
                    <div className="update-field-modal-buttons">
                        <Button
                            text="Update"
                            onClick={() => handleSubmit()}
                            suppressBottomMargin={true}
                        />
                        <Button
                            text="Cancel"
                            onClick={() => setModalOpen(false)}
                            suppressBottomMargin={true}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default ProspectUpdateEmailPopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/ProspectUpdateEmailPopup.tsx